import { Component, inject, signal } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OuiButton } from 'omnium-ui/button';
import { OuiDialogModule } from 'omnium-ui/dialog';
import { OuiTextfield, OuiValidationError } from 'omnium-ui/form-field';
import { OuiIconModule } from 'omnium-ui/icon';
import { OuiLoading } from 'omnium-ui/loading';

export interface HabilitationDesactivationDialogData {
  habilitationName: string;
}

const confirmationErrorMessage =
  'Saisissez DESACTIVER (en majuscules) pour pouvoir confirmer';

@Component({
  selector: 'lib-habilitation-desactivation-dialog',
  standalone: true,
  imports: [OuiDialogModule, OuiButton, OuiIconModule, OuiLoading, OuiTextfield],
  templateUrl: './habilitation-desactivation-dialog.component.html',
  styleUrl: './habilitation-desactivation-dialog.component.scss',
})
export class HabilitationDesactivationDialogComponent {
  private readonly fb = inject(NonNullableFormBuilder);
  private readonly dialogRef = inject(
    MatDialogRef<HabilitationDesactivationDialogComponent>
  );
  private readonly data: HabilitationDesactivationDialogData = inject(MAT_DIALOG_DATA);

  readonly habilitationName = this.data.habilitationName;
  readonly isLoading = signal<boolean>(false);
  readonly confirmationControl = this.fb.control('', [
    Validators.required,
    Validators.pattern(/^DESACTIVER$/),
  ]);
  readonly confirmationErrors: OuiValidationError[] = [
    {
      code: 'pattern',
      message: confirmationErrorMessage,
    },
    {
      code: 'required',
      message: confirmationErrorMessage,
    },
  ];

  deactivateHabilitation() {
    if (!this.confirmationControl.valid) {
      this.confirmationControl.markAllAsTouched();
      return;
    }

    this.dialogRef.close(true);
  }
}
